import {eventChannel} from 'redux-saga';
import {select, take, call, put} from 'redux-saga/effects';
import * as savActionTypes from '../savActionTypes';

const onSAVMapClickSelectTowingDestination = function* onSAVMapClickSelectTowingDestination(payload) {
    const {serviceManager} = yield select(state => state.application);
    const {serviceCaseId, serviceAssignmentLineNo} = payload;
    const arcGISMapService = serviceManager.loadService('arcGISMapService');

    const arcGISMap = yield call(arcGISMapService.getMap, 'service-assignment-vehicle');
    const savTowingDestinationsLayer = yield call(arcGISMap.getLayer, 'sav-towing-destinations');
    const savTowingDestinationRoutesLayer = yield call(arcGISMap.getLayer, 'sav-towing-destination-routes');

    const locationsLayerClickEventChannel = eventChannel(emitter => {
        if (savTowingDestinationsLayer) {
            const unsubscribeClickListener = savTowingDestinationsLayer.on('feature-select', payload => {
                emitter(payload);
            });

            // returns unsubscribe method to eventChannel
            return () => unsubscribeClickListener();
        }
        return () => {};
    });

    while (true) {
        const {featureDTO: towingDestinationFeatureDTO} = yield take(locationsLayerClickEventChannel);
        const {serviceAssignments} = yield select(state => state.serviceAssignments);
        const serviceAssignment = serviceAssignments[`${serviceCaseId}-${serviceAssignmentLineNo}`];
        const {towingDestinationRecommendations} = serviceAssignment;

        if (towingDestinationFeatureDTO && !towingDestinationFeatureDTO.isSelected) {
            const selectedTowingDestinationLocationId = towingDestinationFeatureDTO['locationId'];
            const newTowingDestination = towingDestinationRecommendations
                .find(towingDestination => towingDestination.id === selectedTowingDestinationLocationId);

            yield call(savTowingDestinationRoutesLayer.selectFeatureByAttribute, {
                where: `locationId = '${selectedTowingDestinationLocationId}'`,
            });

            yield put({
                type: savActionTypes.SET_SAV_SELECTED_TOWING_DESTINATION_LOCATION_ID,
                payload: {
                    serviceAssignmentId: `${serviceCaseId}-${serviceAssignmentLineNo}`,
                    selectedTowingDestinationLocationId: selectedTowingDestinationLocationId,
                },
            });

            yield put({
                type: savActionTypes.SUBMIT_SAV_TOWING_DESTINATION_FORM,
                payload: {
                    serviceAssignmentLineNo: serviceAssignmentLineNo,
                    serviceCaseId: serviceCaseId,
                    serviceAssignmentData: {
                        towingDestination: newTowingDestination,
                        towingDestinationRoute: newTowingDestination?.routeToReferentialPoint,
                    },
                },
            });
        }
    }
};

export default onSAVMapClickSelectTowingDestination;
